import * as PropTypes from "prop-types"
import React, { memo } from "react"
import { isMobileOnly } from "react-device-detect"

import Logo from "./Logo"
import MobileMenu from "./MobileMenu"
import Navigation from "./Navigation"

const Header = ({
  list,
  logo,
  isHome,
  showLangMenu,
  handleLanguageChange,
  landingData,
  pathname,
  availableLang,
  userLang,
  translations,
  isItaly
}) => {
  const logoMobileModifier = isMobileOnly ? "logo--short" : ""
  const headerHomeModifier = isHome ? "" : " page__header--subpage"

  return (
    <header className={`page__header ${isItaly ? "page__header--it" : ""} flex-centered ${headerHomeModifier}`}>
      <div className="page__inner flex-space-between">
        <Logo modifier={`${logoMobileModifier}`} logo={logo} />
        <div className="page__header--menu">
          {(isItaly || !isMobileOnly) && (
            <Navigation
              list={list}
              showLangMenu={showLangMenu}
              handleLanguageChange={handleLanguageChange}
              availableLang={availableLang}
              userLang={userLang}
              translations={translations}
              isItaly={isItaly}
            />
          )}
          {isMobileOnly && !landingData && !isItaly && (
            <MobileMenu
              list={list}
              isHome={pathname === "/"}
              showLangMenu={showLangMenu}
              handleLanguageChange={handleLanguageChange}
              availableLang={availableLang}
              userLang={userLang}
              logo={logo}
              isItaly={isItaly}
            />
          )}
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  logo: PropTypes.string.isRequired,
  isHome: PropTypes.bool.isRequired,
  showLangMenu: PropTypes.bool.isRequired,
  handleLanguageChange: PropTypes.func,
  landingData: PropTypes.bool,
  pathname: PropTypes.string.isRequired,
  availableLang: PropTypes.arrayOf(PropTypes.any),
  userLang: PropTypes.string.isRequired,
  translations: PropTypes.objectOf(PropTypes.any).isRequired,
  isItaly: PropTypes.string
}

Header.defaultProps = {
  handleLanguageChange: null,
  landingData: false,
  availableLang: null,
  isItaly: false
}

export default memo(Header)
